import { useEffect, useState } from 'react'
import { DecodeHtml } from '../../utils/decodeHtml'
import ModelButton from '../modelBtn/modelButton'
import Accordion from '../campusLife/accordion'

const ISSSection = ({ internationalOffice }) => {
  const title = internationalOffice?.iSSTitle
  const description = internationalOffice?.iSSInfo?.markup
  const docsTitle = internationalOffice?.iSSDocsTitle
  const [accordion, setAccordion] = useState([])

  const dependentVisaTitle = internationalOffice?.dependentVisaTitle
  const dependentVisaContents = internationalOffice?.dependentVisaContents
    ? internationalOffice?.dependentVisaContents?.markup
    : null
  const iSSFAQTitle = internationalOffice?.iSSFAQTitle
  const iSSFAQContents = internationalOffice?.iSSFAQContents
    ? internationalOffice?.iSSFAQContents?.markup
    : null

  useEffect(() => {
    if (internationalOffice?.iSSDocsContents === null) return
    const setAccordionData = () => {
      const data = internationalOffice?.iSSDocsContents?.items?.map(item => {
        item = item?.content?.properties
        return {
          open: false,
          question: item?.label,
          answer: DecodeHtml({ html: item?.accordionContent?.markup })
        }
      })
      setAccordion(data)
    }
    setAccordionData()
  }, [internationalOffice?.iSSDocsContents])

  //   const [currentContent, setCurrentContent] = useState(null)

  //   const documents =
  //     internationalOffice?.iSSDocsContent !== null
  //       ? internationalOffice?.iSSDocsContents?.items?.map((item, index) => {
  //           item = item?.content?.properties
  //           return {
  //             label: item?.label,
  //             content: DecodeHtml({ html: item?.accordionContent?.markup })
  //           }
  //         })
  //       : []
  return (
    <>
      <div className='flex justify-center p-4 md:py-8 w-full'>
        <div className='flex flex-col gap-20 lg:px-16'>
          {title && description && (
            <div className='flex flex-col gap-5'>
              <h1 className='w-auto text-2xl font-bold text-slate-900  2xl:text-5xl leading-tight'>
                {title}
              </h1>
              {description && DecodeHtml({ html: description })}
            </div>
          )}
          {docsTitle && accordion && accordion.length > 0 && (
            <div className='flex flex-col gap-5'>
              <h1 className='w-auto text-2xl font-bold text-slate-900  2xl:text-5xl leading-tight'>
                {docsTitle}
              </h1>
              {/* <div className='flex flex-col items-start gap-2 border border-gray-300 rounded-lg p-4'>
              {documents.map((doc, index) => (
                <button
                  key={index}
                  className='text-sky-600 text-lg font-semibold underline underline-offset-4 cursor-pointer'
                  onClick={() => setCurrentContent(doc)}
                >
                  {doc.label}
                </button>
              ))}
            </div> */}
              <Accordion accordion={accordion} setAccordion={setAccordion} />
            </div>
          )}
          {dependentVisaTitle && dependentVisaContents && (
            <div className='flex flex-col gap-5'>
              <h1 className='w-auto text-2xl font-bold text-slate-900  2xl:text-5xl leading-tight'>
                {dependentVisaTitle}
              </h1>
              {dependentVisaContents &&
                DecodeHtml({ html: dependentVisaContents })}
            </div>
          )}
          {iSSFAQTitle && iSSFAQContents && (
            <div className='flex flex-col gap-5'>
              <h1 className='w-auto text-2xl font-bold text-slate-900  2xl:text-5xl leading-tight'>
                {iSSFAQTitle}
              </h1>
              {iSSFAQContents && DecodeHtml({ html: iSSFAQContents })}
            </div>
          )}
        </div>
      </div>
      {/* <ModelButton
        modalOpen={currentContent}
        close={() => {
          setCurrentContent(null)
        }}
      >
        <div className='max-h-[90dvh] max-w-[90vw] overflow-y-auto p-4 lg:p-8 flex flex-col gap-5'>
          <h1 className='w-auto text-2xl font-bold text-slate-900  2xl:text-5xl leading-tight'>
            {currentContent?.label}
          </h1>
          {currentContent?.content}
        </div>
      </ModelButton> */}
    </>
  )
}

export default ISSSection
